import type { CSSProperties } from 'react'
import { BRACKET_META, bracketMetaLabel } from '../../lib/bracketMeta'
import i18n, { useLanguageTick } from '../../i18n'

/**
 * The five power brackets as a compact colored strip. Doubles as brand
 * decoration on the input landing and, with `shimmer`, as the analyzing-state
 * loading affordance. `active` dims the other segments to spotlight one bracket.
 */
export default function BracketPrimer({
  shimmer = false,
  active,
  caption = true,
}: {
  shimmer?: boolean
  active?: number
  caption?: boolean
}) {
  useLanguageTick()
  return (
    <div className="space-y-2">
      <div className="flex items-stretch gap-1.5">
        {BRACKET_META.map((b, i) => (
          <div key={b.bracket} className="flex-1 flex flex-col items-center gap-1.5">
            <div
              className={`h-2 w-full rounded-full ${shimmer ? 'bracket-shimmer' : ''}`}
              style={{
                backgroundColor: b.hex,
                opacity: active && active !== b.bracket ? 0.3 : 1,
                ['--i' as string]: i,
              } as CSSProperties}
            />
            <span className="text-[10px] sm:text-xs text-gray-500 font-medium">{bracketMetaLabel(b, 'short')}</span>
          </div>
        ))}
      </div>
      {caption && (
        <p className="text-center text-[11px] text-gray-600">
          {i18n.t('common:input.primer_caption')}
        </p>
      )}
    </div>
  )
}
